import { Injectable } from '@angular/core';
import { SnackMessageComponent } from '@app/modules/shared/components/snack-message/snack-message.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class SnackBarService {
  // https://github.com/angular/material2/issues/7764
  // viewContainerRef: this.shell.viewContainerRef



  constructor( private snackBar: MatSnackBar ) {

  }

  flashConfirm( message: string ) {
    this.snackBar.openFromComponent<SnackMessageComponent>( SnackMessageComponent, {
      data: { message: message },
      panelClass: ['iq-snack-bar', 'is-confirm']
    });
  }

  flashError( message: string ) {
    this.snackBar.openFromComponent<SnackMessageComponent>( SnackMessageComponent, {
      data: { message: message },
      panelClass: ['iq-snack-bar', 'is-error']
    });
  }

}
